import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { isDefined, functor } from "../utils";

class VWAPTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, labelFill, className } = this.props;
    const { yDisplayFormat, yLabel, yAccessor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const currentItem = displayValuesFor(this.props, moreProps);

    const rawValue =
      isDefined(currentItem) && isDefined(yAccessor(currentItem))
        ? yAccessor(currentItem)
        : undefined;

    // Check if VWAP is in error state (daily or higher periodicity)
    const isError = rawValue === "INTRADAY_ONLY";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    if (isError) {
      // Show error message in red
      return (
        <g
          className={className}
          transform={`translate(${x}, ${y})`}
          onClick={onClick}
          data-evo-id="tooltip-vwap-1"
        >
          <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
            <ToolTipTSpanLabel
              x={0}
              dy="5"
              fill={labelFill}
            >{`${yLabel}: `}</ToolTipTSpanLabel>
            <tspan fill="#FF0000">Apenas calculado no intraday!</tspan>
          </ToolTipText>
        </g>
      );
    }

    // Normal display
    const yDisplayValue = isDefined(rawValue)
      ? yDisplayFormat(rawValue)
      : "n/a";

    // Don't render if no value
    if (yDisplayValue === "n/a") {
      return null;
    }

    const valueFill = this.props.valueFill || labelFill;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-vwap-2"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel
            x={0}
            dy="5"
            fill={labelFill}
          >{`${yLabel}: `}</ToolTipTSpanLabel>
          <tspan fill={valueFill}>{yDisplayValue}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

VWAPTooltip.propTypes = {
  yDisplayFormat: PropTypes.func.isRequired,
  yLabel: PropTypes.string.isRequired,
  labelFill: PropTypes.string.isRequired,
  valueFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  displayValuesFor: PropTypes.func,
};

VWAPTooltip.defaultProps = {
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default VWAPTooltip;
